export const HeaderForm = ({ title }: { title: string }) => {
  return (
    <>
      <h2 className="text-xs font-semibold text-[#b0b0b0] whitespace-nowrap uppercase">{title}</h2>
      <hr className="flex-1 mx-2 border-[#5d5d5d]" />
    </>
  )
}